import { useEffect, useRef } from 'react';

/**
 * Am Handy lösen Liste und Unterhaltung einander ab — ein Ebenenwechsel wie ein Seitenwechsel.
 * Ohne Nachführung landet der Fokus danach auf `body`; die neue Ebene bekommt ihn. Der erste
 * Aufbau ist ausgenommen, dort hat niemand etwas ausgelöst.
 */
export function useLayerFocus(mobile: boolean, selectedId: string | null) {
  const layer = useRef<HTMLElement>(null);
  const previous = useRef<string | null>(null);
  useEffect(() => {
    const current = selectedId ?? '';
    if (mobile && previous.current !== null && previous.current !== current) {
      layer.current?.focus({ preventScroll: true });
    }
    previous.current = current;
  }, [mobile, selectedId]);
  return layer;
}
